import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import MagicButton from 'components/MagicButton/MagicButton';
import { AssetUrls } from 'config/assets';
import './DeleteWantListModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const DeleteWantListModal: React.FC<Props> = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  const [confirmText, setConfirmText] = useState('');

  const isConfirmationValid = confirmText === 'DELETE ALL';

  const handleConfirm = () => {
    if (isConfirmationValid) {
      onConfirm();
    }
  };

  const handleClose = () => {
    setConfirmText('');
    onClose();
  };

  if (!isOpen) return null;

  const modalContent = (
    <div className="delete-modal-overlay" onClick={handleClose}>
      <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-header">
          <h2 className="delete-modal-title">⚠️ WARNING!</h2>
          <button className="delete-close-button" onClick={handleClose}>
            <img
              src={AssetUrls.icons.dropdowns.close}
              alt="Close"
              style={{ width: 16, height: 16 }}
            />
          </button>
        </div>

        <div className="delete-modal-content">
          <div className="delete-warning-message">
            <p>Are you sure you want to delete all of the records on your want list?</p>
            <p className="delete-warning-emphasis">This action cannot be undone.</p>
          </div>

          <div className="delete-confirmation-section">
            <label className="delete-label">
              Please type <span className="delete-code">DELETE ALL</span> into the text field to confirm:
            </label>
            <input
              type="text"
              className="delete-input"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type DELETE ALL"
              disabled={isLoading}
            />
          </div>
        </div>

        <div className="delete-modal-footer">
          <MagicButton
            label="Cancel"
            color="grey"
            onPress={handleClose}
            isDisabled={isLoading}
            fullWidth={false}
          />
          <MagicButton
            label={isLoading ? "Deleting..." : "Delete All"}
            color="purple"
            onPress={handleConfirm}
            isDisabled={!isConfirmationValid || isLoading}
            isLoading={isLoading}
            fullWidth={false}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default DeleteWantListModal;